<template>
  <div class="geo-card-header">
    <multiselect
      v-model="cityValue"
      :options="cityList"
      :placeholder="$t('feed.audit.geo.multiselect.placeholder')"
      :max-height="150"
      :deselectLabel="$t('feed.audit.geo.multiselect.deselectLabel')"
      :selectLabel="$t('feed.audit.geo.multiselect.selectLabel')"
      :selectedLabel="$t('feed.audit.geo.multiselect.selectedLabel')"
    />
  </div>
</template>

<script>
  // components
  import Multiselect from 'vue-multiselect'

  export default {
    name: "GeoHeader",
    props: {
      chartName: {
        type: String
      },
      cityList: {
        type: Array
      },
      activeCity: {
        type: String
      },
    },
    computed: {
      cityValue: {
        get() {
          return this.activeCity;
        },
        set(value) {
          this.$emit('setCity', value);
        }
      }
    },
    components: {
      Multiselect,
    }
  };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  @import "../../../../../../../../style/cardHeaderTitle.css";
  .geo-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
</style>
